import { getAllBeneficiariesData } from "../../../../http";
import * as beneficiarySlice from "../../../../Redux/Beneficiary-Slice/Beneficiary-slice";
import { saveSbsSubscriberData } from "../../../../Redux/B2CSubscriber-Slice/Subscriber-sbs-slice";

export const getAllBen = async (subId:string,dispatch:any) => {
    
    try {

      const { data } = await getAllBeneficiariesData(subId);
      
      // Store beneficiary data
      dispatch(beneficiarySlice.saveBeneficiary(data.data));
      
      // Extract and store company name from first beneficiary
      if (data?.data && data.data.length > 0 && data.data[0]?.company?.name) {
        const companyName = data.data[0].company.name;
        dispatch(saveSbsSubscriberData({ companyName }));
      }
      
      return data;

    } catch (error:any) {
      if(error.response?.data){
        throw error.response.data;
      }
      throw error;
      
    }
  };
  